import React, { Component } from 'react';
import FakeData from '.././fake-data';
import { Link } from 'react-router-dom';
import { Helmet } from "react-helmet";
import './CREATE.css';
import { ItemPicker, Modal, ComboBox, TagView } from '.././components/Common';


export default class CREATE extends Component {
  constructor(props) {
    super(props)
    this.state = {

    }
  }


  componentWillMount() {
    var params = FakeData.getQueries(this.props.location.search);
    this.setState({ isAfterReg: params.isAfterReg });
  }


  render() {
    const User = FakeData.getData("yoo")
    return (
      <div className="create-main-container">
        <Helmet
          title={"Create Page"}
          meta={[
            { "name": "description", "content": "" },
            { property: "og:type", content: "Create Page" },
            { property: "og:title", content: "Create Page" },
            { property: "og:image", content: "" },
            { property: "og:url", content: FakeData.baseURL + "/#" + this.props.location.pathname + this.props.location.search }
          ]}
        />
        {this.state.isAfterReg &&
          <CreateItem path="" srcPath="images/personal_profile.svg" label="CONTINUE TO PROFILE" name="Profile" />
        }
        <CreateItem path="/create/team" hasWarning={true} warningText="This team cannot be added to any club or institution, therefore it's a standalone team under a certain sport" srcPath="images/team.svg" label="CREATE A TEAM PROFILE" name="Team" />
        <CreateItem path="/create/club" hasWarning={true} warningText="A club can have multiple sports and multiple teams" srcPath="images/club.svg" label="CREATE A CLUB PROFILE" hideSelectBox={true} name="Club" />
        <CreateItem path="/create/tournament" srcPath="images/league.svg" label="CREATE A TOURNAMENT" name="Tournament" />
        <CreateItem path="/create/institution" hasWarning={true} warningText="An institution can be a school, college or a university with multiple sports and multiple teams" srcPath="images/institution_icon.svg" label="CREATE EDUCTIONAL INSTITUTION PROFILE" hideSelectBox={true} name="Institutional" />
        <CreateItem path="" srcPath="images/game_icon.svg" label="CREATE GAME & GMC" name="GMC" />
      </div>
    );
  }
}

class CreateItem extends Component {
  constructor(props) {
    super(props)
    this.state = {
      isAction: false,
      data: {},
      tournTypes: [
        "league",
        "group_knockout",
        "knockout"
      ]
    }
  }

  willLeave() {
    this.setState({
      isAction: false
    });
  }

  render() {
    const sports = (FakeData.getData("all_sports")) ? FakeData.getData("all_sports") : [];
    return (
      <div className={(this.state.isAction) ? "create-item active" : "create-item"} onMouseLeave={() => {
        const _that = this
      }} onClick={() => {
        if (!FakeData.shared("createPage")) {
          FakeData.shared("createPage", this)
          if (this.props.name === "Profile") {

            return;
          }

          this.setState({
            isAction: true
          });
        } else {
          FakeData.shared("createPage").willLeave()
          FakeData.shared("createPage", this)

          if (this.props.name === "Profile") {

            return;
          }
          this.setState({
            isAction: true
          });
        }
      }}>
        {(this.props.name === "Profile") &&
          <Link  to={{ pathname: "/profile/" + FakeData.getCookie("supotsu-user").split("-")[1], search: '?sInit=about' }} className="create-item-placeholder">
            <img src={this.props.srcPath} />
            <h2>{this.props.label}</h2>
          </Link>
        }

        {(this.props.name !== "Profile") &&
          <div className="create-item-placeholder">
            <img src={this.props.srcPath} />
            <h2>{this.props.label}</h2>
          </div>
        }
        {(this.props.name !== "GMC") &&
          <div className="create-item-form">
            <h4>{this.props.label}</h4>
            {(!this.props.hideSelectBox) &&
              <select value={"Select " + this.props.name + " Sport"} onChange={(e) => {
                this.state.data['sport'] = e.target.value
                this.setState({
                  data: this.state.data
                });
              }}>
                <option value="" disabled>{"Select " + this.props.name + " Sport"}</option>
                {
                  sports.map((sport, i) => {
                    return (<option key={i} value={sport.name}>{sport.name}</option>)
                  })
                }
              </select>
            }
            {(this.props.name === "Tournament") &&
              <select value={"Select " + this.props.name + " Type"} onChange={(e) => {
                this.state.data['type'] = e.target.value
                this.setState({
                  data: this.state.data
                });
              }}>
                <option value="" disabled>{"Select " + this.props.name + " Type"}</option>
                {
                  this.state.tournTypes.map((item, i) => {
                    return (
                      <option value={item} key={i}>{item.replace("_", " ").capitalize()}</option>
                    )
                  })
                }
              </select>
            }
            <input placeholder={(this.props.name === "Institutional") ? "Institution Name" : this.props.name + " Name"} onChange={(e) => {
              this.state.data['name'] = e.target.value
              this.setState({
                data: this.state.data
              });
            }} />
            {(this.props.hasWarning) &&
              <p>
                <strong>NB: </strong> {this.props.warningText}
              </p>
            }
            <p style={{ fontSize: "11px", margin: "0px!important" }}>By clicking Create, you agree to the <a href="somepage.xyz">Supotsu Terms.</a></p>
            <Link  to={this.props.path} className="button" onClick={(e) => {
              const data = this.state.data

              if (!data.name || (!this.props.hideSelectBox && !data.sport)) {
                e.preventDefault()
              }

              if (this.props.name === "Tournament" && !data.type) {
                e.preventDefault()
              }

              FakeData.setData(this.props.name.toLowerCase() + "Store", data)
            }}>CREATE</Link>
          </div>
        }

        {(this.props.name === "GMC") &&
          <div className="create-item-form">
            <h4>{this.props.label}?</h4>
            <p>GMC content is only managed through the GMC Page</p>
            <Link  to="/gmc" className="button">Visit Page</Link>
          </div>
        }

      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/CREATE.js